import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayFinalreconEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/finalrecon/`
        this.webApi = new WebApi()
    }

    async getList (filter) {
        const entities = await this.webApi.post(`${this.url}list`, filter)
        if (entities) {
            if (!entities.status_code) {
                if (!entities.error) {
                    return entities
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${entities.status_code}`)
            }
        }
        return null
    }
}
